"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentList = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("../../list/styles");
const rich_content_element_1 = require("../rich-content-element");
const types_1 = require("./types");
const RichContentList = ({ path = 'root', children, bold, italic, color, fontSize }) => {
    let listItems;
    if (children === null || children === void 0 ? void 0 : children.items) {
        listItems = children.items;
    }
    else {
        return null;
    }
    const renderedListItems = listItems.map(function (listItem, i) {
        return (react_1.default.createElement("li", { key: i },
            react_1.default.createElement(rich_content_element_1.RichContentElement, { bold: bold, italic: italic, path: path, color: color, fontSize: fontSize }, listItem)));
    });
    if (!(children === null || children === void 0 ? void 0 : children.type)) {
        return react_1.default.createElement(styles_1.StyledUnorderedList, { "data-cy": "unordered-list" }, renderedListItems);
    }
    else {
        switch (children.type) {
            case types_1.ListAttributes.ORDERED:
                return react_1.default.createElement(styles_1.StyledOrderedList, { "data-cy": "ordered-list" }, renderedListItems);
            case types_1.ListAttributes.UNORDERED:
            case types_1.ListAttributes.NOSTYLE:
            default:
                return react_1.default.createElement(styles_1.StyledUnorderedList, { "data-cy": "unordered-list" }, renderedListItems);
        }
    }
};
exports.RichContentList = RichContentList;
